import { SERVER_URL } from "../utils/constants";

const changeUserNotes = async (id, notes) => {
  const response = await fetch(`${SERVER_URL}/changeUserNotes`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, notes }),
  });
  if (response.status === 400) {
    throw new Error("Nie udało się zmienić uwag");
  }
  return await response.json();
};

export default changeUserNotes;
